import { ApplicationConfig, LOCALE_ID, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withViewTransitions } from '@angular/router';
import { provideToastr } from 'ngx-toastr';

import { routes } from './app.routes';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { errorInterceptor } from './error-handling/error.interceptor';
import { environment } from '../environments/environment';

const routerFeatures = environment.production ? [withViewTransitions()] : [];

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, ...routerFeatures),
    provideHttpClient(withInterceptors([errorInterceptor])),
    { provide: LOCALE_ID, useValue: 'sv-SE' },
    { provide: MAT_DATE_LOCALE, useValue: 'sv-SE' },
    provideToastr({
      positionClass: 'toast-top-left',
      timeOut: 5000,
      preventDuplicates: true,
      maxOpened: 5,
    }),
  ],
};
